import courses from './courses'
import certificates from './certificates'

export default [...courses, ...certificates] as const
